/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from 'react';
import * as CustomWidgets from '.';
import * as API from '../../http/api';
import { useHistory } from 'react-router-dom';
import { makeStyles, createStyles } from '@mui/styles';
import { Avatar, Button, ButtonGroup, Card, CardContent, CardHeader, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Theme, Tooltip, Typography } from '@mui/material';
import { Build, Edit, EditAttributes, Menu, Settings, AssignmentInd, Add, Delete, AddCircle, Remove, DeleteForever } from '@mui/icons-material';
import FormRole from '../modals/FormRole';
import { openlightbox } from '../../util/Functions';
import DataTable from 'react-data-table-component';
import { theme, customStyles } from '../../util/TableStyles';
import { noDataComponent } from "../../util/DataObject";
import { ThemeProvider } from '@mui/material/styles';
import DeleteRol from '../modals/DeleteRol';


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        titlesTabs: {
            textRendering: "geometricPrecision",
            WebkitFontSmoothing: "antialiased !important",
            scrollBehavior: "smooth",
            fontFamily: "Muli,sans-serif !important",
            color: "#969BA0 !important",
            //fontWeight: 'bold'
        },
        contentTab: {
            padding: "10px !important",
        },
        firstTitle: {
            padding: "16px",
        },
        titleTable: {
            display: "flex",
            width: "100%",
        },
        buttonAdd: {
            marginLeft: "88% !important",
        },
        titleH2: {
            display: "flex",
        },
        iconTitle: {
            marginTop: "4px",
            marginRight: "5px",
        },
        textField: {
            marginLeft: theme.spacing(1),
            display: "flex !important",
            width: "25% !important",
            margin: "auto !important",
            marginRight: "0 !important",
        },
    })
);

const RoleList = (props) => {
    const [list, setList] = useState([]);
    const [total, setTotal] = useState(0);
    const [limit, setLimit] = useState(5);
    const history = useHistory();

    useEffect(() => {
        init();
    }, [props.content]);

    const init = () => {
        if(props.content.roles){
            setList(JSON.parse(JSON.stringify(props.content.roles)));
        }

        if(props.content.hasOwnProperty('total')){
            setTotal(props.content.total);
        }

        if(props.content.hasOwnProperty('limit')){
            setLimit(props.content.limit);
        }
    }

    const openModal = (uuid, name) => {
		let modal = {
			uuid: uuid,
			name: name,
		};
		const as = <DeleteRol
			pos={props.pos}
			changeAlert={props.changeAlert}
			changeLoader={props.changeLoader}
			contentModal={modal}
			deleteRol={deleteRol}
			key="deleteRol"
		/>
		openlightbox(as);
	};

    const deleteRol = async (uuid) => {
		props.changeLoader(true);
		let data = {};
		if (uuid) {
			data["uuid"] = uuid;
		}

		let request = await API.service("deleteRol", data, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status == 200 && request.data.data.response == "OK") {
			await reloadData({});
            props.changeAlert(true, "success", "Rol eliminado con éxito");
		}

		props.changeLoader(false);
	};

    const reloadData = async (data) => {
        props.changeLoader(true);
        let request = await API.service('adminRoles', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == 'OK') {
            props.changeWidgets(JSON.parse(JSON.stringify(request.data.data.widget)));
        }
    
        props.changeLoader(false);
    };

    const createFormRole = async (uuid) => {
        props.changeLoader(true);
        let data = {};
        if (uuid) {
            data["uuid"] = uuid;
        }
    
        let request = await API.service('formRole', data, props.pos, props.changeAlert, props.changeLoader, history);

        if (request.status == 200 && request.data.data.response == "OK") {
            let widg = [];
            widg = request.data.data.widget;
            if (widg[0].type == 'formRole' && widg[0].content) {
                const as = (
                    <FormRole
                        pos={props.pos}
                        changeAlert={props.changeAlert}
                        changeLoader={props.changeLoader}
                        contentModal={widg[0]?.content}
                        reloadData={reloadData}
                        key="formRole"
                    />
                );
                openlightbox(as);
            }
        }
        props.changeLoader(false);
    };

    const findWidgets = async (uuid) => {
        props.changeLoader(true);
        let data = {};
        if (uuid) {
            data['uuid'] = uuid;
        }
    
        let request = await API.service('findWidgets', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == "OK") {
            let widg = [];
            widg = request.data.data.widget;
            if (widg[0].type == 'widgetsConfig' && widg[0].content) {
                let w = props.widgets[0];
                let widgUpdate = [w, widg[0]];
                props.changeWidgets(JSON.parse(JSON.stringify(widgUpdate)));
            }
        }
        props.changeLoader(false);
    }

    const findIntents = async (uuid) => {
        props.changeLoader(true);
        let data = {};
        if (uuid) {
            data['uuid'] = uuid;
        }
    
        let request = await API.service('findIntents', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == "OK") {
            let widg = [];
            widg = request.data.data.widget;
            if (widg[0].type == 'intentsConfig' && widg[0].content) {
                let w = props.widgets[0];
                let widgUpdate = [w, widg[0]];
                props.changeWidgets(JSON.parse(JSON.stringify(widgUpdate)));
            }
        }
        props.changeLoader(false);
    }

    const paginationComponentOptions = {
		rangeSeparatorText: 'de',
		rowsPerPageText: 'Registros por página',
	};

    const findMenus = async (uuid) => {
        props.changeLoader(true);
        let data = {};
        if (uuid) {
            data['uuid'] = uuid;
        }
    
        let request = await API.service('findMenus', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == "OK") {
            let widg = [];
            widg = request.data.data.widget;
            if (widg[0].type == 'menusConfig' && widg[0].content) {
                let w = props.widgets[0];
                let widgUpdate = [w, widg[0]];
                props.changeWidgets(JSON.parse(JSON.stringify(widgUpdate)));
            }
        }
        props.changeLoader(false);
    }

    const columns = [
        { selector: (row) => row.name, name: "Nombre", width: "20%", wrap: true, sortable: true },
        { selector: (row) => row.uuid, name: "UUID", width: "40%", wrap: true, sortable: true },
        { selector: (row) => row.unit_name, name: "Grupo", width: "15%", wrap: true, sortable: true },
        {
			cell: (row) => {
				return <Typography
					fontWeight="400"
					fontFamily="Muli,sans-serif"
					color="#000000de"
					fontSize="0.875rem"
				>
					<Tooltip title="Editar">
                        <IconButton onClick={createFormRole.bind(this, row.uuid)}>
                            <Edit/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Modificar widgets">
                        <IconButton onClick={findWidgets.bind(this, row.uuid)}>
                            <Settings/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Modificar intents">
                        <IconButton onClick={findIntents.bind(this, row.uuid)}>
                            <Build/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Modificar menu">
                        <IconButton onClick={findMenus.bind(this, row.uuid)}>
                            <Menu/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Eliminar">
                        <IconButton onClick={openModal.bind(this, row.uuid, row.name)}>
                            <DeleteForever/>
                        </IconButton>
                    </Tooltip>
				</Typography>
			}, name: 'Acciones', width: '25%', center: true
		}
    ]

    const changePage = async (value) => {
		let data = {
			page: value,
			limit: limit
		}
		//setPage(p);
		await reloadData(data);
	};

	const changeTotal = async (e) => {
		let data = {
			page: 1,
			limit: e
		}
		await reloadData(data);
	};

    return <Card sx={{width: '100%', padding: "2vw"}}>
        <CardHeader
            sx={{width: '100%'}}
            title={
                <div style={{display: 'inline-flex', width: '100%'}}>
                    <Typography
                        component={'h3'} 
                        fontFamily="Muli,sans-serif"
                        fontSize="18px"
                        fontWeight={600}
                        sx={{color: '#3E3E42', width: '2%'}}
                    >
                        <AssignmentInd/>
                    </Typography>
                    <Typography
                        component={'h3'} 
                        fontFamily="Muli,sans-serif"
                        fontSize="18px"
                        fontWeight={600}
                        sx={{color: '#3E3E42', marginLeft: '0.5%'}}
                    >
                        Roles
                    </Typography>
                </div>
            }
            action={
                <div style={{margin: '40px !important'}}>
                    <Tooltip title="Agregar rol">
                        <IconButton onClick={createFormRole.bind(this, '')}>
                            <AddCircle/>
                        </IconButton>
                    </Tooltip>
                </div>
            }
        />
        <CardContent>
            <Grid container>
                <ThemeProvider theme={theme}>
                    <DataTable
                        columns={columns} 
                        data={list}
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                        pagination
                        paginationServer
                        paginationTotalRows={total}
                        onChangePage={changePage}
                        paginationPerPage={props.content.limit}
                        paginationRowsPerPageOptions={[5,10,20,30,40,50]}
                        onChangeRowsPerPage={changeTotal}
                        noDataComponent={noDataComponent}
                    />
                </ThemeProvider>
            </Grid>
        </CardContent>
    </Card>
}

export default RoleList;